
class ActivityList {
	constructor () {
		this._dataRequests = [];
		this.init();
	}

	init(){
		this._itemArray = [];
		this._idsArray = [];
		this.index = null;
		this._pending = [];
	}

	getData () {
		if (!this._dataRequests.length) return;

		API.fetch(
			'activities',
			{
				activityIds: this._dataRequests
			}
		)
		.then(reply => {
			if (reply.activities && Array.isArray(reply.activities)) {
				reply.activities.forEach((data) => {
					let i = this._idsArray.indexOf(data._id);
					this._itemArray[i].loadArray(data);
					i = this._dataRequests.indexOf(data._id);
					this._dataRequests.splice(i, 1);
				});
			}
		})
	}
	
	addActivity(activity) {
		if (!activity.id) return activity;

		let i = this._idsArray.indexOf(activity.id);
		if (0 <= i) return this._itemArray[i];

		this._idsArray.push(activity.id);
		this._itemArray.push(activity);
		this.index = this._idsArray.length - 1;
		return activity;
	}

	findById(activityId) {
		let i = this._idsArray.indexOf(activityId);
		if (0 <= i) return this._itemArray[i];

		this._dataRequests.push(activityId);
		return this.addActivity(Activity.placeholder(activityId));
	}

	indexPending(activity) {
		let i = this._pending.indexOf(activity);

	}

	getLast() {
		// return the last activity added to the list
		return this._itemArray[this._idsArray.length - 1];
	}

	clear(){
		// reset the list to empty list (alias for init)
		this.init();
	}

	reset(){
		// return the number of activity in the list
		this.index = -1;
		return this._idsArray.length;
	}
}
